<template>
  <div class="menu">
    <label class="toggle-container" for="toggle">
      <span class="button button-toggle material-icons">menu</span>
    </label>
  </div>
</template>
